import {selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

import {clientsServicesStore} from '@store/clients/services/clients-services.store';
import {getClientsServicesDataSource} from '@store/clients/services/clients-services.requests';

export class ClientsServicesQuery {
  store = clientsServicesStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  clientsServices$ = getClientsServicesDataSource.data$();
  selectedClientsServices$ = this.store.pipe(
    selectManyByPredicate((clientsServiceUI) => clientsServiceUI.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  get tableFilters() {
    return this.store.getValue().filters.tableFilters;
  }
}

export const clientsServicesQuery = new ClientsServicesQuery();
